/*
 * @Description: login状态管理
 * @Author: 安知鱼
 * @Email: 2268025923@qq.com
 * @Date: 2021-08-30 10:27:31
 * @LastEditTime: 2022-03-04 18:20:24
 * @LastEditors: 安知鱼
 */
import { Module } from 'vuex'
import { ElMessage } from 'element-plus'

import Cache from '@/utils/cache'
import router from '@/router'

import {
  accountLoginRequest,
  phoneLoginRequest,
  getPhoneCodeRequest,
  requestUserInfoById,
  resetPasswordRequest,
  registerRequest
} from '@/service/login/login'

import {
  IAccount,
  IPhone,
  IRegister,
  IResetPassword
} from '@/service/login/type'
import { ILoginState } from './type'
import { IRootStore } from '../type'

const loginModule: Module<ILoginState, IRootStore> = {
  namespaced: true,
  state() {
    return {
      token: '',
      userMenus: [],
      permissions: [],
      code: ''
    }
  },
  mutations: {
    changeToken(state, token: string) {
      state.token = token
    },
    changeCode(state, code: string) {
      state.code = code
    }
  },
  actions: {
    async accountLoginAction({ commit }, payload: IAccount) {
      // 1. 实现账号密码登录逻辑(记得将此处修改为请求)
      console.log(payload)
      // const loginResult = await accountLoginRequest(payload)
      // console.log(loginResult)

      // const { token, id } = loginResult.data
      // commit('changeToken', token)
      // Cache.setCache('token', token)

      // 2.请求用户信息(记得将此处修改为请求)
      // const userInfoResult = await requestUserInfoById(id)
      // const userInfo = userInfoResult.data
      // commit('account/changeUserInfo', userInfo, { root: true })
      // Cache.setCache('userInfo', userInfo)

      // 5.跳转首页
      router.push('/main/home')
    },
    async getPhoneCode({ commit }, payload: string) {
      const loginResult = await getPhoneCodeRequest(payload)
      if (loginResult.code === '200') {
        const { code } = loginResult.data
        commit('changeCode', code)
      } else {
        ElMessage.error('获取验证码失败!')
      }
    },
    async phoneLoginAction({ commit }, payload: IPhone) {
      // 1. 实现手机登录逻辑
      const loginResult = await phoneLoginRequest(payload)
      if (loginResult.code === '200') {
        const { id, token } = loginResult.data
        commit('account/changeUserInfo', token)
        Cache.setCache('token', token)

        // 3.请求用户信息
        const userInfoResult = await requestUserInfoById(id)
        const userInfo = userInfoResult.data
        commit('changeUserInfo', userInfo, { root: true })
        Cache.setCache('userInfo', userInfo)

        // 5.跳转首页
        router.push('/main')
      } else {
        ElMessage.error('登录失败!')
      }
    },
    async registerAction(context, payload: IRegister) {
      console.log(payload)

      // 1. 实现注册逻辑
      const registerResult = await registerRequest(payload)

      if (registerResult.code === '200') {
        ElMessage.success('注册成功！')
        // 2. 跳转登录页
        router.push('/login')
      } else {
        ElMessage.error('注册失败!')
      }
    },
    async resetPassword(context, payload: IResetPassword) {
      // 1. 实现重置逻辑
      const resetPasswordResult = await resetPasswordRequest(payload)

      if (resetPasswordResult.code === '200') {
        ElMessage.success('重置密码成功！')
        // 2. 跳转登录页
        window.location.href = './'
      } else {
        ElMessage.error('重置密码失败!')
        return
      }
    },
    loadLocalLogin({ commit }) {
      const token = Cache.getCache('token')
      if (token) {
        commit('changeToken', token)
      }
      const userInfo = Cache.getCache('userInfo')
      if (userInfo) {
        commit('account/changeUserInfo', userInfo, { root: true })
      }
    }
  }
}

export default loginModule
